import React, {
  Fragment,
  useState,
  useEffect,
  useCallback,
  useContext,
} from 'react';
import styled from 'styled-components';
import useDimension from '../../hooks/use-dimension';
import {Context} from '../../AppContext';
const config = require('../../data.json');

export default function Item(props) {
  let {index, item, spec, columns, order, orderItems = []} = props;
  const [product, setProduct] = useState(null);
  const app = useContext(Context);
  const {dimension} = useDimension();
  const isSmallScreen = dimension.outerWidth <= config.breakpoints.lg;

  useEffect(() => {
    (async () => {
      try {
        setProduct(
          app.actions.getProductFromSpec({
            spec,
            productName:
              order?.order_type === 'custom' ? '自定義商品' : item.name,
          }),
        );
      } catch (err) {
        console.warn(err);
      }
    })();
  }, [app.actions, item.name, spec]);

  const orderItem = orderItems.find(
    (orderItem) => orderItem.item_index === index,
  );
  let disabled = false;

  if (order && orderItem) {
    disabled =
      ['refunding', 'refunded', 'voided', 'completed'].includes(
        order.display_state,
      ) ||
      (orderItem && orderItem.status === 'accepted');
  }

  let params = {
    item,
    index,
    product,
    orderItem,
    disabled,
  };

  return (
    <Row>
      {columns.map((col, idx) => (
        <Col
          key={idx}
          style={{
            ...col.style,
            ...(isSmallScreen ? {flex: 1, width: '100%'} : {}),
          }}
          className={col.className}>
          {isSmallScreen && <Label>{col.label}</Label>}
          {typeof col.render === 'function'
            ? col.render(params)
            : item[col.name]}
        </Col>
      ))}
    </Row>
  );
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: white;
  flex: ${(props) => props.flex || 1};
  padding: 30px 15px;
  position: relative;
  border-bottom: solid 1px ${config.colors.border};
  ${(props) => props.css}

  @media only screen and (max-width: ${config.breakpoints.lg}px) {
    flex-direction: column;
    align-items: stretch;
    padding-bottom: 0;
  }
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${(props) => props.flex || 1};
  color: ${(props) => props.color || '#505050'};
  padding-right: 50px;

  &.hide-rwd {
    @media only screen and (max-width: ${config.breakpoints.lg}px) {
      display: none;
    }
  }

  @media only screen and (max-width: ${config.breakpoints.lg}px) {
    flex-direction: row;
    align-items: center;
    margin-bottom: 15px;
    padding-right: 30px;
  }

  @media only screen and (max-width: ${config.breakpoints.sm}px) {
    flex-direction: column;
    align-items: flex-start;
    margin-bottom: 15px;
    padding-right: 0px;
  }

  ${(props) => props.css}
`;

// small screen label
const Label = styled.div`
  flex: ${(props) => props.flex || '0 0 120px'};
  color: #505050;
  font-weight: 600;
  @media only screen and (min-width: ${config.breakpoints.lg}px) {
    display: none;
  }

  @media only screen and (max-width: ${config.breakpoints.sm}px) {
    flex: ${(props) => props.flex || '0 0'};
    margin-bottom: 5px;
  }
`;
